import React from 'react';
import { cn } from '@/lib/utils';

export default function KlaroLogo({ compact = false, header = false, className }) {
  const src = compact
    ? '/brand/klaro-logo-compact.svg'
    : header
      ? '/brand/klaro-logo-header.png'
      : '/brand/klaro-logo.svg';
  return (
    <span className={cn('inline-flex items-center', className)} aria-label="Klaro">
      <img src={src} alt="Klaro" className={compact ? 'h-10 w-10 object-contain' : 'h-10 w-auto object-contain'} draggable={false} />
    </span>
  );
}

